import { ReactNode } from 'react';

import { GhostPostOrPage } from "../../utils/api/ghost/ghost-interfaces";
import RenderContent from "@core/components/display/html/RenderContent";

type GhostPageProps = {
    showTitle?: boolean;
    fullWidth?: boolean;
    children?: ReactNode;
    className?: string;
    fetchedGhostPage?: GhostPostOrPage | null;
};

const GhostPage = (props: GhostPageProps) => {
    const { showTitle, fullWidth, children, className, fetchedGhostPage } = props;

    return (
        <section>
            <div>
                {showTitle && (
                    <div className="flex">
                        {fetchedGhostPage && fetchedGhostPage.title && (
                            <h2 className="text-2xl leading-6 font-semibold text-gray-900">{fetchedGhostPage.title}</h2>
                        )}
                    </div>
                )}
                <div id="ghost-content-section">
                    <RenderContent
                        html={fetchedGhostPage && fetchedGhostPage.html}
                        fullWidth={fullWidth}
                        className={className}
                    >
                        {children}
                    </RenderContent>
                </div>
            </div>
        </section>
    );
};

export default GhostPage;
